let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2HA9A")).then(() => parcelRequire('f7aUi'));